import { render, staticRenderFns } from "./News.vue?vue&type=template&id=3689a2d6&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"
import style0 from "./News.vue?vue&type=style&index=0&id=3689a2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3689a2d6",
  null
  
)

export default component.exports